import { cva } from 'class-variance-authority';

export const priceVariants = cva(
  'price group grid [grid-template-rows:repeat(5,auto)] [grid-template-areas:"a"_"b"_"c"_"d"_"e"]',
  {
    variants: {
      alignment: {
        left: 'justify-items-start',
        center: 'justify-items-center',
        right: 'justify-items-end',
      },
      size: {
        default: '',
        small: 'price-size-small',
      },
    },
    defaultVariants: {
      alignment: 'left',
      size: 'default',
    },
  },
);
